import { render, staticRenderFns } from "./PackingListPdf.vue?vue&type=template&id=04aef0d9&"
import script from "./PackingListPdf.vue?vue&type=script&lang=js&"
export * from "./PackingListPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports